// extracted by mini-css-extract-plugin
module.exports = {"sample_list":"sample_list__EnBjZgJOUIqh+"};